import { contactApi, contactQueryKeys } from "service/crm/api/contact";
import { useActivityFeed } from "../useActivityFeed";

export const useContactActivity = (contactUuid: string, pageSize = 20) =>
  useActivityFeed(
    contactQueryKeys.activities(contactUuid),
    (page) =>
      contactApi.getContactActivities(contactUuid, page, pageSize, "ALL_ACTIVITIES"),
    !!contactUuid,
  );